import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import LoadingSpinner from './LoadingSpinner';
import { useAuth } from '../context/AuthContext';

type Props = {
  children: React.ReactElement;
};

const ProtectedRoute: React.FC<Props> = ({ children }) => {
  const { isAuthenticated, isReady, status } = useAuth();
  const location = useLocation();

  if (!isReady) {
    return <LoadingSpinner />;
  }

  if (!isAuthenticated) {
    if (status === 'pending' && location.pathname === '/dashboard') {
      return children;
    }
    if (status === 'pending') {
      return <Navigate to="/dashboard" replace />;
    }
    return <Navigate to="/auth" replace state={{ from: location }} />;
  }

  return children;
};

export default ProtectedRoute;
